<template>
  <nav class="navbar">
    <div class="inner">
      <section class="logo">
        <a
          href="#"
          v-scroll-to="'#hero'"
          v-if="
            $store.getters['dom/isMobile'] ||
            $store.getters['dom/isExtraSmall'] ||
            $store.getters['dom/isTablet']
          "
        >
          <img :src="require(`@/assets/images/logo/${mobilelogoSrc}`)" alt="" />
        </a>
        <a href="#" v-scroll-to="'#hero'" v-else>
          <!-- <img :src="require(`@/assets/images/${logoSrc}`)" alt="" /> -->
          <img :src="require(`@/assets/images/logo/${mobilelogoSrc}`)" alt="" />
        </a>
      </section>

      <section class="main_nav">
        <div>
          <button
            type="button"
            class="burger"
            :class="{ active: isActive }"
            @click="toggleBurger"
          >
            <span class="burger-line"></span>
            <span class="burger-line"></span>
            <span class="burger-line"></span>
            <span class="burger-line"></span>
          </button>
          <div class="menu" :class="{ active: isActive }" ref="menuRef">
            <ul class="menu-inner" v-scroll-spy-active>
              <!--  v-scroll-spy-link -->

              <li class="menu-item" @click="toggleBurger">
                <a
                  href="#"
                  class="menu-link"
                  v-scroll-to="'#hero'"
                  style="color: #fff !important"
                >
                  Home
                </a>
              </li>

              <li class="menu-item" @click="toggleBurger">
                <a
                  href="#"
                  class="menu-link"
                  v-scroll-to="'#allstar'"
                  style="color: #fff !important"
                >
                  The Future Looks Bright
                </a>
              </li>
              <li class="menu-item" @click="toggleBurger">
                <a
                  href="#"
                  class="menu-link"
                  v-scroll-to="'#perks'"
                  style="color: #fff !important"
                >
                  Membership Benefits
                </a>
              </li>
              <!-- <li class="menu-item" @click="toggleBurger">
                <a
                  href="#"
                  class="menu-link"
                  v-scroll-to="'#tenure'"
                  style="color: #fff !important"
                >
                  Membership Tenure
                </a>
              </li> -->
              <li class="menu-item" @click="toggleBurger">
                <a
                  href="#"
                  class="menu-link"
                  v-scroll-to="'#pricing'"
                  style="color: #fff !important"
                >
                  Seating & Pricing
                </a>
              </li>
              <!-- <li class="menu-item" @click="toggleBurger">
              <a
                href="#"
                v-scroll-to="'#next-steps'"
                class="menu-link"
                style="color: #fff !important"
              >
                Next Steps
              </a>
            </li> -->
              <!-- <li class="menu-item" @click="toggleBurger">
              <a href="#" class="menu-link" v-scroll-to="'#meet_rep'" style="color: #fff !important;">
				contact us
				</a>
            </li> -->
              <!-- <li class="menu-item" @click="toggleBurger">
              <a
                href="#"
                class="menu-link"
                v-scroll-to="'#meet_rep'"
                style="color: #fff !important"
              >
                Your Rep
              </a>
            </li> -->
              <li class="menu-item" @click="toggleBurger">
                <a
                  href="https://www.belmontparkvillage.com/"
                  target="_blank"
                  class="menu-link"
                  style="color: #fff !important"
                >
                  Belmont Park Village
                </a>
              </li>
              <li class="menu-item" @click="toggleBurger">
                <a
                  href="#"
                  class="menu-link"
                  v-scroll-to="'#faqs'"
                  style="color: #fff !important"
                >
                  FAQ
                </a>
              </li>
              <button
                class="modalBtn mobile"
                @click.prevent="(e) => $emit('modalShow', 'show')"
              >
                Get in touch
              </button>
            </ul>
          </div>
        </div>
      </section>

      <button
        class="modalBtn"
        @click.prevent="(e) => $emit('modalShow', 'show')"
      >
        Get in touch
      </button>
    </div>
  </nav>
</template>

<script>
import { ref, reactive, watch, toRefs, computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "Header",
  setup() {
    const menuRef = ref();
    const store = useStore();

    // State
    const state = reactive({
      isActive: false,
      theme: computed(() => store.getters["dom/getTheme"]),
      logoSrc: computed(() => "logo-mainmenu.svg"),
      mobilelogoSrc: computed(() => "logo-with-year.svg"),
    });

    watch(state, () => {
      if (state.isActive) {
        menuRef.value.style.maxHeight = menuRef.value.scrollHeight + "px";
      } else {
        menuRef.value.removeAttribute("style");
      }
    });

    // Methods
    function toggleBurger() {
      state.isActive = !state.isActive;
    }
    function modeToggle() {
      const mode = state.theme === "light" ? "dark" : "light";
      store.commit("dom/SET_THEME", mode);
    }
    return {
      ...toRefs(state),
      toggleBurger,
      menuRef,
      store,
      modeToggle,
    };
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  max-width: 100%;
  height: auto;
  // margin: 30px auto;
  padding: 15px;
  border: none;
  outline: none;
  background: #00468b;
  position: fixed;
  width: 100%;
  top: 0;
  display: flex;
  // flex-direction: row;
  z-index: 10;
  // box-shadow: 2px 1px #000000;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  justify-content: flex-start;
  @include media-breakpoint-down(sm) {
    flex-direction: column;
    align-items: unset;
    // z-index: 12;
  }
  @media only screen and (min-width: 900px) and (max-width: 1200px) {
    flex-direction: column;
    align-items: unset;
    // z-index: 12;
  }
  @media (max-width: 990px) {
    flex-direction: column;
    align-items: unset;
  }

  .inner {
    max-width: 1620px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @include media-breakpoint-down(sm) {
      flex-direction: column;
      align-items: unset;
      // z-index: 12;
    }
    @media only screen and (min-width: 900px) and (max-width: 1200px) {
      flex-direction: column;
      align-items: unset;
      // z-index: 12;
    }
    @media (max-width: 990px) {
      flex-direction: column;
      align-items: unset;
    }
  }
  .optInOffer {
    font-family: "Prompt";
    font-size: 15px;
    color: #ffffff;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
    background: #f16924;
    text-decoration: none;
    padding: 8px 20px;
    transition: all 0.25s ease-in-out;
  }
  .top_nav {
    // display: flex;
    // width: 100%;
    justify-content: center;
    margin-top: 6px;

    a {
      font-size: 12px;
      font-weight: 700;
      //font-family: "AntaTrial-Bold";
      @include media-breakpoint-down(sm) {
        font-size: 8px;
      }
      line-height: 15px;
      text-align: center;
      color: theme-var($--ch-theme-primary) !important;
      text-transform: uppercase;
      text-decoration: none;
      margin-left: 20px;
      &:first-child {
        margin-left: 0;
        margin-right: auto;
      }
    }
  }
  .logo {
    // margin: 25px auto;
    text-align: center;
    @include media-breakpoint-down(sm) {
      text-align: left;
    }
    @media (max-width: 990px) {
      text-align: left;
    }
    img {
      height: 50px;
      // margin-top: -25px;
      border-radius: 0px;
      @include media-breakpoint-down(sm) {
        height: auto;
        width: 60px;
      }
    }
  }
  .main_nav {
    background: #00468b;
    // width: 100%;
    .menu {
      width: 100%;
      display: flex;
      justify-content: center;
      font-family: "Prompt";
      letter-spacing: 0.71px;
      text-align: right;
      line-height: 15px;
      font-weight: 700;
      &-item {
        text-align: center;
        line-height: 0.9em;
        padding: 0.5em 1px;
        span {
          font-family: "Helvetica", "Arial", sans-serif;
          font-weight: 700;
        }
        &.router-link-active,
        &:hover {
          .menu-link {
            color: theme-var($--ch-theme-highlight);
          }
        }
        &.active .menu-link {
          color: theme-var($--ch-theme-highlight);
        }
      }
      &-link {
        border: none;
        text-transform: uppercase;
        text-decoration: none;
        text-rendering: optimizeLegibility;
        transition: all 0.35s ease-in-out;
        font-size: 12px;
        font-style: normal;
        line-height: 15px;
        text-align: center;
      }
      &-inner {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        list-style: none;
        margin: 0;
        padding-right: 2rem;
        @include media-breakpoint-down(sm) {
          margin-top: 30px;
        }
        @include media-breakpoint-down(lg) {
          flex-direction: column;
          gap: 0;
          width: 100%;
          padding: 0;
        }
        @media only screen and (min-width: 900px) and (max-width: 1200px) {
          flex-direction: column;
          gap: 0;
          width: 100%;
          padding: 30px 0px;
        }
      }
    }
  }

  .burger {
    position: absolute;
    display: none;
    cursor: pointer;
    width: 2rem;
    height: 1rem;
    border: none;
    outline: none;
    opacity: 0;
    visibility: hidden;
    background: none;
    transform: rotate(0deg);
    transition: 0.35s ease-in-out;
    top: 32px;
    right: 20px;
    @include media-breakpoint-down(lg) {
      display: block;
      opacity: 1;
      visibility: visible;
    }
    @media only screen and (min-width: 900px) and (max-width: 1200px) {
      display: block;
      opacity: 1;
      visibility: visible;
    }

    @include media-breakpoint-down(sm) {
      top: 20.78px;
    }
    &-line {
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      left: 0;
      border: none;
      outline: none;
      opacity: 1;
      border-radius: 0.25rem;
      background: #fff;
      transform: rotate(0deg);
      transition: 0.25s ease-in-out;

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2),
      &:nth-child(3) {
        top: 0.5rem;
      }

      &:nth-child(4) {
        top: 1rem;
      }
    }

    &.active {
      .burger-line {
        &:nth-child(1),
        &:nth-child(4) {
          top: 1.25rem;
          width: 0%;
          left: 50%;
        }

        &:nth-child(2) {
          transform: rotate(45deg);
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
        }
      }
    }
  }

  .menu {
    @include media-breakpoint-down(lg) {
      width: 100%;
      max-height: 0rem;
      padding: 0;
      opacity: 0;
      visibility: hidden;
      overflow: hidden;
      transition: all 0.35s ease;
      justify-content: center;
      align-items: flex-start;
    }
    @media only screen and (min-width: 900px) and (max-width: 1200px) {
      width: 100%;
      max-height: 0rem;
      padding: 0;
      opacity: 0;
      visibility: hidden;
      overflow: hidden;
      transition: all 0.35s ease;
      justify-content: center;
      align-items: flex-start;
    }

    &.active {
      @include media-breakpoint-down(lg) {
        opacity: 1;
        visibility: visible;
      }
      @media only screen and (min-width: 900px) and (max-width: 1200px) {
        opacity: 1;
        visibility: visible;
        max-height: 450px !important;
      }
    }
    &-inner {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 2rem;
      list-style: none;
      margin: 0;
      @include media-breakpoint-down(lg) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 0.75rem;
        padding: 1rem 0;
      }
      @media only screen and (min-width: 900px) and (max-width: 1200px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 0.75rem;
        padding: 1rem 0;
      }
    }
    &-link {
      font-size: 0.7rem;
      font-weight: 500;
      line-height: inherit;
      border: none;
      text-transform: uppercase;
      text-decoration: none;
      text-rendering: optimizeLegibility;
      transition: all 0.35s ease-in-out;
      color: theme-var($--ch-theme-on-secondary);
      &.router-link-active,
      &:hover {
        border: none;
        outline: none;
        color: theme-var($--ch-theme-highlight);
      }
      @include media-breakpoint-down(lg) {
        width: 100%;
        br {
          display: none;
        }
      }
      @media only screen and (min-width: 900px) and (max-width: 1200px) {
        width: 100%;
        br {
          display: none;
        }
      }
    }
  }
  .mode-toggle {
    position: relative;
    //margin: auto .5rem .5rem auto;
    padding: 0;
    width: 44px;
    height: 24px;
    min-width: 36px;
    min-height: 20px;
    background-color: theme-var($--ch-theme-secondary);
    border: 0;
    border-radius: 24px;
    outline: 0;
    overflow: hidden;
    cursor: pointer;
    z-index: 2;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-touch-callout: none;
    appearance: none;
    transition: background-color 0.5s ease;
    margin-left: 20px;
    .toggle {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 3px solid transparent;
      box-shadow: inset 0 0 0 2px theme-var($--ch-theme-on-secondary);
      overflow: hidden;
      transition: transform 0.5s ease;
      &:before {
        content: "";
        position: relative;
        width: 100%;
        height: 100%;
        left: 50%;
        float: left;
        background-color: theme-var($--ch-theme-on-secondary);
        transition: border-radius 0.5s ease, width 0.5s ease, height 0.5s ease,
          left 0.5s ease, transform 0.5s ease;
      }
    }
    &.dark {
      // background-color: theme-var($--ch-theme-secondary);
      .toggle {
        transform: translateX(19px);
        &:before {
          border-radius: 50%;
          width: 150%;
          height: 85%;
          left: 40%;
          transform: translate(-10%, -40%), rotate(-35deg);
        }
      }
    }
  }

  .modalBtn {
    margin-left: auto;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    width: auto;
    height: auto;
    padding: 14px 24px 10px;
    font-size: 18px;
    line-height: normal;
    text-transform: uppercase;
    transition: all 0.2s linear;
    border-radius: 0;
    border: none;
    outline: none;
    transform: scale(1);
    color: white;
    background-color: transparent;
    font-weight: 700;
    border: 2px solid var(--Orange, #f16924);
    font-family: Prompt;

    @media screen and (max-width: 1200px) {
      display: none;
    }

    &.mobile {
      display: none;

      @media screen and (max-width: 1200px) {
        display: inline-block;
        margin: 30px auto 0;
      }
    }

    &:hover {
      border: 2px solid white;
      background-color: #f16924;
    }
  }
}
</style>
